// Types
import { FetchClubDetailsQuery } from '@typings/operations';

export default (vendors: FetchClubDetailsQuery['club']['vendors']) =>
  vendors.map(({ vendorName, startDate }) => ({
    name: vendorName,
    startDate: startDate,
  })) || [];
